// The design system a venue is shown in, as GET /inventory/venue/{id} returns it on `theme`.
const VenueTheme = {
  Socashless: "socashless-design-system",
  Soar: "soar-design-system",
};

export default VenueTheme;
